/**
 * SEE-272: Control Center credit limit, served by the CDK v2-paidol Lambda.
 * Support users only (server-side assert_support). Amounts are cents.
 */

const SUPPORT_CREDIT_LIMIT_FIELDS = /* GraphQL */ `
  paidolId
  speedchainCreditLimit
  highnoteCreditLimit
  availableCredit
  highnoteReadFailed
`;

export const getCreditLimitAsSupportQuery = /* GraphQL */ `
  query GetCreditLimitAsSupport($paidolId: ID!) {
    getCreditLimitAsSupport(paidolId: $paidolId) {
      ${SUPPORT_CREDIT_LIMIT_FIELDS}
    }
  }
`;

export const pullCreditLimitFromHighnoteMutation = /* GraphQL */ `
  mutation PullCreditLimitFromHighnote($paidolId: ID!) {
    pullCreditLimitFromHighnote(paidolId: $paidolId) {
      ${SUPPORT_CREDIT_LIMIT_FIELDS}
    }
  }
`;

export const setCreditLimitAsSupportMutation = /* GraphQL */ `
  mutation SetCreditLimitAsSupport($paidolId: ID!, $creditLimit: Float!) {
    setCreditLimitAsSupport(paidolId: $paidolId, creditLimit: $creditLimit) {
      ${SUPPORT_CREDIT_LIMIT_FIELDS}
    }
  }
`;
